import React, { ReactNode, useContext, useState } from "react";
import { API_PATH } from "../constants/common";
import { CurrencyT } from "../graphql/generated/graphql";

export type OrganizationTypeT = { id: string; name: string };

type StateT = {
  apiToken?: string;
  apiUri: string;
  currency: CurrencyT;
  currentUrl: string;
  defaultLocale: string;
  host: string;
  urlLocale: string;
};

type AppSettiongsContextT =
  | null
  | (StateT & {
      setAppSettingsState: React.Dispatch<React.SetStateAction<StateT>>;
    });

const rootElement = document.getElementById("shoptet-root") as HTMLElement;

const host = rootElement.dataset.host || "/";

const defaultState = {
  host,
  apiToken: rootElement.dataset.apiToken as string,
  apiUri: `${host}${API_PATH}`,
  currentUrl: rootElement.dataset.appUrl as string,
  urlLocale: rootElement.dataset.urlLocale as string,
  defaultLocale: rootElement.dataset.defaultLocale as string,
  currency: rootElement.dataset.currency as CurrencyT,
};

const AppSettingsContext = React.createContext<AppSettiongsContextT>(null);

export const AppSettingsProvider = (props: { children: ReactNode }) => {
  const [state, setState] = useState<StateT>(defaultState);

  return (
    <AppSettingsContext.Provider value={{ ...state, setAppSettingsState: setState }}>
      {props.children}
    </AppSettingsContext.Provider>
  );
};

export const useAppSettings = () => {
  const context = useContext(AppSettingsContext);
  if (!context) {
    throw new Error("Component is outside appSettings provider");
  }
  return context;
};
